export default __webpack_public_path__ + "static/media/Notification-icon.6a5f5619.svg";